import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

// ─── Layout ───────────────────────────────────────────────

export const ProjectContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "calc(90vh - 100px)",
  overflow: "hidden",
});

export const TabBar = styled(Box)({
  display: "flex",
  gap: "0.25rem",
  marginBottom: "1rem",
  borderBottom: "1px solid #e2e8f0",
  paddingBottom: "0",
});

export const TabButton = styled(Box)<{ active?: boolean }>(({ active }) => ({
  padding: "8px 20px",
  cursor: "pointer",
  fontSize: "0.875rem",
  fontWeight: active ? 600 : 400,
  color: active ? "#e91e63" : "#64748b",
  borderBottom: active ? "2px solid #e91e63" : "2px solid transparent",
  marginBottom: "-1px",
  transition: "all 0.2s ease",
  userSelect: "none",
  "&:hover": {
    color: active ? "#e91e63" : "#334155",
  },
}));

export const TabContent = styled(Box)({
  flex: 1,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
});

// ─── Toolbar ──────────────────────────────────────────────

export const ToolbarRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  marginBottom: "1rem",
  flexShrink: 0,
});

export const SearchInput = styled(TextField)({
  flex: 1,
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f8fafc",
    borderRadius: "0.5rem",
    "& fieldset": { borderColor: "#e2e8f0" },
    "&:hover fieldset": { borderColor: "#cbd5e1" },
    "&.Mui-focused fieldset": { borderColor: "#3b82f6", borderWidth: "1px" },
  },
  "& .MuiInputBase-input": {
    padding: "8px 12px",
    fontSize: "0.875rem",
  },
});

export const SortButton = styled(IconButton)({
  padding: "8px",
  border: "1px solid #e2e8f0",
  borderRadius: "0.5rem",
  color: "#64748b",
  "&:hover": { backgroundColor: "#f8fafc" },
});

export const CreateButton = styled(Button)({
  backgroundColor: "#fce4ec",
  color: "#e91e63",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "0.875rem",
  padding: "8px 16px",
  borderRadius: "0.5rem",
  boxShadow: "none",
  whiteSpace: "nowrap",
  "&:hover": { backgroundColor: "#f8bbd9", boxShadow: "none" },
});

export const CreateMenuContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#fff",
  border: "1px solid #f1f5f9",
  borderRadius: "0.5rem",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  overflow: "hidden",
  marginTop: "0.5rem",
  position: "absolute",
  top: "100%",
  right: 0,
  zIndex: 10,
  minWidth: "180px",
});

export const CreateMenuItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  padding: "10px 16px",
  cursor: "pointer",
  transition: "background-color 0.2s",
  "&:hover": { backgroundColor: "#f8fafc" },
});

export const CreateMenuText = styled(Typography)({
  fontSize: "0.8rem",
  color: "#64748b",
});

export const CreateMenuWrapper = styled(Box)({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
});

// ─── List ──────────────────────────────────────────────────

export const ScrollableList = styled(Box)({
  flex: 1,
  overflowY: "auto",
  overflowX: "hidden",
});

export const EmptyState = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  color: "#94a3b8",
  textAlign: "center",
  padding: "2rem",
  marginTop: "1rem",
});

export const DashedEmptyState = styled(Box)({
  textAlign: "center",
  padding: "3rem",
  color: "#64748b",
  border: "2px dashed #e2e8f0",
  borderRadius: "0.75rem",
  marginTop: "1rem",
});

export const DividerBox = styled(Box)({
  height: "1px",
  backgroundColor: "#e2e8f0",
  margin: "0.5rem 0 1rem 0",
  flexShrink: 0,
});
/** ปุ่ม "โหลดเพิ่ม" ท้ายลิสต์ที่แบ่งหน้าจาก server */
export const LoadMoreButton = styled(Button)({
  width: "100%",
  marginTop: "0.5rem",
  padding: "0.5rem",
  textTransform: "none",
  fontSize: "0.8rem",
  color: "#64748b",
  border: "1px dashed #cbd5e1",
  borderRadius: "0.5rem",
  "&:hover": { backgroundColor: "#f8fafc", borderColor: "#94a3b8" },
  "&.Mui-disabled": { color: "#cbd5e1", borderColor: "#e2e8f0" },
});
